// extracted by mini-css-extract-plugin
export default {"NameWrapper":"NameWrapper__lk4ti","LeftBorder":"LeftBorder__WZG0Y","MiddleBorder":"MiddleBorder__FcOEe","Root":"Root__0piuG"};